import i18next from 'i18next';
import { toast } from 'react-toastify';

import { createFace, extractAttributes } from '@vlabs/api/luna-api/client';
import type { FaceId, ListId } from '@vlabs/api/luna-api/model';

import type { CardId } from '@vlabs/api/point-api/model';

export const createFaceFromSample = async ({
  sampleId,
  cardId,
  lists = undefined,
}: {
  sampleId: string;
  cardId: CardId;
  lists?: ListId[];
}): Promise<FaceId | undefined> => {
  try {
    const extractAttributesResp = await extractAttributes([sampleId], {
      extract_basic_attributes: 1,
    });
    const createdFaceResp = await createFace({
      attribute: {
        attribute_id: extractAttributesResp?.[0]?.attribute_id,
      },
      lists,
      external_id: cardId,
      avatar: `/6/samples/faces/${sampleId}`,
    });

    return createdFaceResp.face_id;
  } catch {
    toast.error(i18next.t('features:createCard.create_card_modal.errors.face'));
    return undefined;
  }
};
